module.exports = __webpack_public_path__ + "static/img/shan.2ca2147e.svg";